/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Footer_CoachInputs */

const en_portal_footer_coach = /** @type {(inputs: Portal_Footer_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For coaches`)
};

const pl_portal_footer_coach = /** @type {(inputs: Portal_Footer_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla trenerów`)
};

/**
* | output |
* | --- |
* | "For coaches" |
*
* @param {Portal_Footer_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_footer_coach = /** @type {((inputs?: Portal_Footer_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Footer_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_footer_coach(inputs)
	return en_portal_footer_coach(inputs)
});